<template>
  <!-- Card -->
  <mdb-container>
    <mdb-row class="py-5">
      <mdb-col></mdb-col>
      <mdb-col>
        <mdb-card wide>
          <mdb-card-body>
            <form id="loginform">
                <mdb-btn size="sm" color="white" icon="angle-left" v-on:click="goBack()" type="submit"></mdb-btn>
                <mdb-card-title class="py-3 text-center">Registration</mdb-card-title>
              <div class="grey-text">
                <mdb-input
                  label="Your Firstname"
                  icon="envelope"
                  group
                  type="text"
                  v-model="input.firstname"
                />
                <mdb-input
                  label="Your Lastname"
                  icon="envelope"
                  group
                  type="text"
                  v-model="input.lastname"
                />
                <mdb-input
                  label="Your email"
                  icon="envelope"
                  group
                  type="email"
                  validate
                  error="wrong"
                  success="right"
                  v-model="input.email"
                />
                <mdb-input
                  label="Your password"
                  icon="lock"
                  group
                  type="password"
                  validate
                  v-model="input.password"
                />
              </div>
              <div class="text-center py-4 mt-3">
                <mdb-btn color="#9fa8da indigo lighten-2" icon="user-plus" v-on:click="submit()" type="submit">Register</mdb-btn>
              </div>
            </form>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>
      <mdb-col></mdb-col>
    </mdb-row>
  </mdb-container>
  <!-- Card -->
</template>
<script>
import {
  mdbInput,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCardTitle
} from "mdbvue";
//import Vue from 'vue';
export default {
  name: "registration",
  components: {
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCardTitle
  },
  data() {
    return {
      input: {
        email: "",
        password: "",
        firstname: "",
        lastname: ""
      }
    };
  },
  methods: {
    submit() {
      if (this.input.email != "" && this.input.password != "") {
        //Test aus Login.js aus React Project
        console.log("Form submitted");
        event.preventDefault();

        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            Firstname: this.input.firstname,
            Lastname: this.input.lastname,
            eMail: this.input.email,
            Password: this.input.password
          })
        };
        console.log(requestOptions.body);
        console.log(requestOptions.body);
        //fetch('http://localhost:7071/api/CreateOrUpdateUser', requestOptions)
        fetch(
          "https://thitch.azurewebsites.net/api/CreateOrUpdateUser?code=K5z/pOa7OmiEjK789qL9TEXaNkk30ufojaMRjtncWq5VdM1pVXqcdQ==",
          requestOptions
        )
          .then(async response => {
            if (response.ok) {
              this.$router.replace({ name: "login" });
            }
          })
          .catch(error => {
            console.log("Error", error);
          });
      } else {
        alert("empty");
      }
    },
    goBack: function() {
      this.$router.replace({ name: "login" });
    }
  }
};
</script>

<style>
</style>